import { Column, Row } from '@/components/lib/components';
import { Event } from '@/feature/event-details-sbk/types';
import { TeamOrder } from '@/utils/sport-utils';

import { MarketColumn as MarketColumnData } from '../utils';
import { EmptyMarketColumn } from './EmptyMarketColumn';
import { MarketColumn } from './MarketColumn';

type MarketColumnsProps = {
    event: Event;
    marketColumns: MarketColumnData[];
    totalRows: number;
    teamOrder: TeamOrder;
    showHeader: boolean;
};

export const MarketColumns = ({ event, marketColumns, totalRows, teamOrder, showHeader }: MarketColumnsProps) => (
    <Column>
        <Row gap="s3">
            {marketColumns.map((column, index) => {
                if (!column.marketType || column.markets.length === 0) {
                    return (
                        <EmptyMarketColumn
                            key={column.header}
                            header={column.header}
                            showHeader={showHeader}
                            columnIndex={index}
                            totalColumns={marketColumns.length}
                            totalRows={totalRows}
                        />
                    );
                }
                return (
                    <MarketColumn
                        key={column.marketType.code}
                        header={column.header}
                        event={event}
                        markets={column.markets}
                        marketType={column.marketType}
                        showHeader={showHeader}
                        columnIndex={index}
                        totalColumns={marketColumns.length}
                        teamOrder={teamOrder}
                    />
                );
            })}
        </Row>
    </Column>
);
